import { render, staticRenderFns } from "./stocks-inquiry.vue?vue&type=template&id=da4337ee&"
import script from "./stocks-inquiry.vue?vue&type=script&lang=js&"
export * from "./stocks-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports